export default "__VITE_ASSET__Bv2c_$oD__"